export default "__VITE_ASSET__Bf0Gj06S__"